import React from 'react'
import './Newsletter.css'

const Newletter = () => {
  return (
    <div className='news-letter'>
      <h1>Get Exclusive Offers On Your Email</h1>
      <p>Subscribe our New letter and stay updated</p>
      <div>
        <input type="email" placeholder='Enter your Email Id'/>
        <button>Subscribe</button>
      </div>
    </div>
  )
}

export default Newletter
